export default __webpack_public_path__ + "strongher-devices_mobile.2bb7a8bc.png";